import { CatalogItemInOrder } from 'entities/CatalogItem/model/types/CatalogItemSchema';

import { OrderProposalFilterSchema } from '../types/OrderProposalFilterSchema';

export const buildSellersDataBySeller = (orderItems: CatalogItemInOrder[]) => {
    const sellersDataBySeller: OrderProposalFilterSchema['filterSellersDataBySeller'] =
        {};

    orderItems.forEach((item) => {
        const selectedProposals = item.selectedProposals;

        if (selectedProposals?.length > 0) {
            selectedProposals.forEach((selectedProposal) => {
                if (!selectedProposal.sellerUid) return;
                if (!selectedProposal.selectedQuantity) return;

                const sellerUid = selectedProposal.sellerUid;
                const proposalTotalPrice =
                    Number(selectedProposal.price || 0) *
                    (selectedProposal.selectedQuantity || 0);

                if (!sellersDataBySeller[sellerUid]) {
                    sellersDataBySeller[sellerUid] = {
                        sellerUid: sellerUid,
                        name: selectedProposal.name,
                        totalPrice: proposalTotalPrice,
                        poNumber: null,
                        itemProposals: [selectedProposal],
                        isCheckFinished: item.isCheckFinished,
                    };
                } else {
                    sellersDataBySeller[sellerUid].totalPrice +=
                        proposalTotalPrice;

                    sellersDataBySeller[sellerUid].itemProposals.push(
                        selectedProposal,
                    );

                    if (!item.isCheckFinished) {
                        sellersDataBySeller[sellerUid].isCheckFinished = false;
                    }
                }
            });
        }
    });

    return sellersDataBySeller;
};
